<template>
    <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Left Arrow 1">
<path id="Vector 60" d="M0.857147 0.75L6 5.25L11.1429 0.75" stroke="#212135" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>

</template>